import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody, Label } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { FieldArray, Formik } from 'formik';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';

export const completeLotsMutation = gql`
  mutation completeLots($breweryId: Int!, $lots: [CompleteLot]!, $permitNumber: String!) {
    completeLots(breweryId: $breweryId, lots: $lots, permitNumber: $permitNumber) {
      id
    }
  }
`;

const CompleteLotsForm = ({ handleSubmit, onCancelClick, lots, errors, isSubmitting }) => (
  <form onSubmit={handleSubmit}>
    <ModalBody>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <div className="mb3">
        <Label>What's the permit number?</Label>
        <FormikInputField name="permitNumber" invalid={!!errors.permitNumber} />
        {errors.permitNumber && <p className="error">{errors.permitNumber}</p>}
      </div>
      <FieldArray
        name="products"
        validateOnChange={false}
        render={() => (
          <Fragment>
            <Label>Lots to complete:</Label>
            <table className="table mb0">
              <tbody>
                {lots.map((l, idx) => (
                  <tr key={l.id}>
                    <td>
                      <FormikInputField type="checkbox" name={`lots.${idx}.dutyPaid`} />
                      <Label>Duty paid?</Label>
                    </td>
                    <td>
                      <strong>{l.reference}</strong>
                    </td>
                    <td>{l.volume}L</td>
                    <td>
                      <em>{l.product.name}</em>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Fragment>
        )}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancelClick}>
        Cancel
      </Button>{' '}
      <SubmissionButton type="submit" color="primary" isSubmitting={isSubmitting}>
        Complete
      </SubmissionButton>
    </ModalFooter>
  </form>
);

export class CompleteLotsModal extends Component {
  state = {
    error: null
  };

  render() {
    const { lots, isOpen, onToggle, onSuccess, brewery, refetchQueries } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Complete these lots</ModalHeader>
        <Mutation mutation={completeLotsMutation}>
          {completeLots => (
            <Formik
              validateOnChange={false}
              validateOnBlur={false}
              initialValues={{
                permitNumber: '',
                lots: lots.map(() => ({
                  dutyPaid: false
                }))
              }}
              onSubmit={async (values, { setErrors, setSubmitting }) => {
                try {
                  await completeLots({
                    variables: {
                      breweryId: brewery.id,
                      permitNumber: values.permitNumber,
                      lots: lots.map((l, idx) => ({
                        id: l.id,
                        dutyPaid: values.lots[idx].dutyPaid
                      }))
                    },
                    awaitRefetchQueries: true,
                    refetchQueries: refetchQueries || ['lot']
                  });
                  onSuccess();
                } catch (err) {
                  console.error(err);
                  setErrors({
                    unknown: 'An unknown error occured'
                  });
                  setSubmitting(false);
                }
              }}
              render={props => (
                <CompleteLotsForm {...props} lots={lots} onCancelClick={onToggle} onSuccess={onSuccess} />
              )}
            />
          )}
        </Mutation>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(CompleteLotsModal);



// WEBPACK FOOTER //
// ./src/containers/completeLotsModal/completeLotsModal.jsx